import { useCallback, useMemo } from "react";
import { useLocation } from "@reach/router";
import { navigate } from "gatsby";

const useSearchParams = (): [
  URLSearchParams,
  (nextParams: URLSearchParams, replace?: boolean) => void
] => {
  const { search } = useLocation();
  const searchParams = useMemo(() => new URLSearchParams(search), [search]);
  const setSearchParams = useCallback((nextParams: URLSearchParams, replace: boolean = false) => {
    navigate(`?${nextParams.toString()}`, { replace });
  }, []);

  return [searchParams, setSearchParams];
};

export default useSearchParams;
